import { render, staticRenderFns } from "./GameComponent.vue?vue&type=template&id=3157f7d4&"
import script from "./GameComponent.vue?vue&type=script&lang=js&"
export * from "./GameComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports